/*
 * Author M. Atoar Rahman
 * Title: Drug Presentation Type
 * Description: Page for Drug Presentation Type
 * Date: 15/03/2022
 */

import React from 'react';
import { Card } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { PresentationTypeProvider } from '../masterSetup/presentationType/ContextAPI';
import DataTable from '../masterSetup/presentationType/DataTable';
import FormInfo from '../masterSetup/presentationType/FormInfo';
import PermissionDenied from './PermissionDenied';

export default function DrugPresentationType() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['drug-presentation-type']) return <PermissionDenied />;

    return (
        <PresentationTypeProvider>
            <Card>
                <Card.Header className="cardHeader">
                    <h3>Drug Presentation Type</h3>
                    <div>
                        <FormInfo />
                    </div>
                </Card.Header>
                <Card.Body>
                    <DataTable />
                </Card.Body>
            </Card>
        </PresentationTypeProvider>
    );
}
